import { render } from "./LeaderBoardCard.vue?vue&type=template&id=71dc0e38&scoped=true&ts=true"
import script from "./LeaderBoardCard.vue?vue&type=script&lang=ts"
export * from "./LeaderBoardCard.vue?vue&type=script&lang=ts"

import "./LeaderBoardCard.vue?vue&type=style&index=0&id=71dc0e38&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71dc0e38"]])

export default __exports__